import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import "./registerServiceWorker"
// @ts-ignore
import {MdApp, MdButton, MdContent, MdDrawer, MdField, MdIcon, MdList, MdToolbar} from "vue-material/dist/components"
import "vue-material/dist/vue-material.min.css"
import VueI18n from "vue-i18n"
import Song from "@/song"
import SongData from "@/assets/songs.json"

Vue.config.productionTip = false
// Vue.use(VueRouter)
Vue.use(VueI18n)
Vue.use(MdApp)
Vue.use(MdToolbar)
Vue.use(MdDrawer)
Vue.use(MdContent)
Vue.use(MdList)
Vue.use(MdButton)
Vue.use(MdIcon)
Vue.use(MdField)

export const songs: Song[] = SongData.songs.sort((left, right) => left.name.localeCompare(right.name))

const uiStrings = {
  en: {
    app_name: "Song Barrel",
    missing_song_title: "Song",
    hint_search: "Search..."
  },
  de: {
    app_name: "Liederfass",
    missing_song_title: "Lied",
    hint_search: "Suchen..."
  }
}

export const i18n = new VueI18n({
  locale: "de", // set locale
  messages: uiStrings
})

const app = new Vue({
  i18n,
  router,
  render: h => h(App),
  el: "#app"
})// .$mount("#app")
